import axios from 'axios';

const FileSearchService = {
    advancedSearch: async (searchParams) => {
        const { query, email, auth, languages, processStages, currentFolder } = searchParams;
        
        try {
            const baseUrl = process.env.REACT_APP_API_URL || '';
            
            // Build the search endpoint URL
            let endpoint = `${process.env.REACT_APP_API_URL}/api/v2/filesystem/search`;
            
            console.log('Sending search request to:', endpoint);

            let processStagesPayload = '';
            
            // processStages is an array of strings, so we need to join them with commas
            // if processStages has LEVEL_0, also add LEVEL_1

            if (processStages && Array.isArray(processStages)) {
                processStagesPayload = processStages.join(',');
                if (processStages.includes('LEVEL0') && !processStages.includes('LEVEL1')) {
                    processStagesPayload += ',LEVEL1';
                }
            }

            let languagesPayload = '';

            // languages is an array of strings, so we need to join them with commas
            if (languages && Array.isArray(languages)) {
                languagesPayload = languages.join(',');
            }
            
            // Make the API request
            const response = await axios.get(endpoint, 
                { 
                    params: {
                        query: query || '',
                        languages: languagesPayload || null,
                        processStages: processStagesPayload || null,
                        currentFolder: currentFolder || null
                    },
               
                    headers: {
                        'Content-Type': 'application/json',
                        email: email,
                        auth: auth,
                    }
                }
            );
            
            console.log('Search API response:', response.data);
            
            if(currentFolder != null && currentFolder !== '/') {
                // If currentFolder is not null, filter the results to include only those in the current folder
                response.data.folders = response.data.folders.filter(folder => folder.path === currentFolder);
                response.data.files = response.data.files.filter(file => file.path === currentFolder);
            }

            // Return the search results
            return {
                folders: response.data.folders || [],
                files: response.data.files || []
            };
        } catch (error) {
            console.error('Search API error:', error);
            throw error;
        }
    }
};

export default FileSearchService;